import { Input } from '@base-ui/react/input'
import clsx from 'clsx'
import { forwardRef } from 'react'

export interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  ({ className, ...props }, ref) => {
    return (
      <Input
        ref={ref}
        className={clsx(
          // Base styles
          'bg-white border border-gray-stroke h-10 w-full rounded-lg px-4 text-base outline-none transition-colors',
          'focus:ring-0 focus:border-lavender disabled:text-charcoal-50 disabled:cursor-not-allowed',
          'placeholder:text-charcoal-50',
          // Invalid state styling using BaseUI data attributes
          'data-invalid:border-brick-light data-invalid:focus:border-brick-light',
          // Additional classes
          className
        )}
        {...props}
      />
    )
  }
)

TextInput.displayName = 'TextInput'
